import React from 'react';
import PropTypes from 'prop-types';

import withData from 'components/withData';

import { SpendCubeSettingsContext } from './';

class Provider extends React.Component {
	static propTypes = {
		children: PropTypes.node.isRequired,
		response: PropTypes.shape({
			loading: PropTypes.bool,
			data: PropTypes.any,
			refetch: PropTypes.func,
		}),
	};

	state = {
		settings: null,
	};

	componentWillReceiveProps(nextProps) {
		const { response } = nextProps;

		if (response.success && !this.props.response.success) {
			this.setState({
				settings: response.data,
			});
		}
	}

	render() {
		return (
			<SpendCubeSettingsContext.Provider
				value={{ ...this.state, refetch: this.props.response.refetch }}
			>
				{this.state.settings || this.props.response.success
					? this.props.children
					: null}
			</SpendCubeSettingsContext.Provider>
		);
	}
}

export const SpendCubeSettingsContextProvider = withData('/rawdata/config')(
	Provider
);
